import * as runtime from '../runtime';
import { IInitializeServiceOptions } from '../types';
import { ISchedule } from './models';

type ICommonScheduleRequest = { id: string; xINFAORGID?: string };
export interface ICreateScheduleRequest {
	schedule: ISchedule;
	xINFAORGID?: string;
}

export class ScheduleService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}

	async getScheduleRaw(
		requestParameters: ICommonScheduleRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<ISchedule>> {
		if (requestParameters.id === null || requestParameters.id === undefined) {
			throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getSchedule.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		const response = await this.request(
			{
				path: `/api/v2/Schedules('{id}')`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async deleteScheduleRaw(
		requestParameters: ICommonScheduleRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<ISchedule>> {
		if (requestParameters.id === null || requestParameters.id === undefined) {
			throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling delete schedule.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		const response = await this.request(
			{
				path: `/api/v2/Schedules('{id}')`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async createScheduleRaw(
		requestParameters: ICreateScheduleRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<ISchedule>> {
		if (requestParameters.schedule === null || requestParameters.schedule === undefined) {
			throw new runtime.RequiredError('schedule', 'Required parameter requestParameters.schedule was null or undefined when calling create schedule.');
		}

		const queryParameters: runtime.HTTPQuery = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xINFAORGID !== undefined && requestParameters.xINFAORGID !== null) {
			headerParameters['X-INFA-ORG-ID'] = String(requestParameters.xINFAORGID);
		}

		const response = await this.request(
			{
				path: `/api/v2/Schedules`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: { ...requestParameters.schedule, orgId: this.tenantId },
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async getSchedule(requestParameters: ICommonScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISchedule> {
		const response = await this.getScheduleRaw(requestParameters, initOverrides);
		return await response.value();
	}

	async createSchedule(requestParameters: ICreateScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISchedule> {
		const response = await this.createScheduleRaw(requestParameters, initOverrides);
		return await response.value();
	}

	async deleteSchedule(requestParameters: ICommonScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ISchedule> {
		const response = await this.deleteScheduleRaw(requestParameters, initOverrides);
		return await response.value();
	}
}

export const initializeScheduleService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const scheduleService = new ScheduleService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs['scheduler'],
		}),
		tenantId,
	);
	return scheduleService;
};
